<template>
  <div class="">
    <div class="search-box">
      <div class="search-item">
        <label>账号名：</label>
        <a-input placeholder="请输入" v-model.trim="searchTerm.alias" />
      </div>
      <div class="search-item">
        <label>手机号：</label>
        <a-input placeholder="请输入"  v-model.trim="searchTerm.account"  />
      </div>
      <div class="search-btn" style="display: inline-block;">
        <a-button type="primary" @click="search">查询</a-button>
        <a-button  @click="reset">重置</a-button>
      </div>
    </div>
    <a-table
      :locale="{
        emptyText: '暂无数据'
      }"
      :columns="columns" 
      @change="handleTableChange" 
      :pagination="pagination"  
      rowKey="id"  
      :data-source="data"  
      style="margin-top: 12px;"
    >
      <span @click="openModal(record.id)"  slot="action" slot-scope="record"><a>订单结算</a></span> 
      <span slot="postpaidAccountBalance">待结算金额(元)
        <a-tooltip placement="bottom"
          :getPopupContainer="
          triggerNode => {
            return triggerNode.parentNode || document.body;
          }"
        >
          <span slot="title">交易完成待供应商结算的订单总额</span>
          <a-icon type="exclamation-circle"/>
        </a-tooltip>
      </span>
    </a-table>
  </div>
</template>
<script>
import page from "@/assets/mixin/page.js";
const columns = [
  {
    title: '账号名',
    dataIndex: 'alias',
    key: 'alias',
    ellipsis:true,
  },
  {
    title:'手机号',
    dataIndex:'account',
    key: 'account',
  },
  {
    dataIndex: 'postpaidAccountBalance',
    key: 'postpaidAccountBalance',
    slots: { title: 'postpaidAccountBalance' },
    align:"right",
    width:"150px"
  },
  {
    title: '操作',
    key: 'action',
    align:"center",
    scopedSlots: { customRender: 'action' },
  },
];
import {mapState} from 'vuex'
export default {
  mixins: [page],
  data() {
    return {
      data:[],
      columns,
    };
  },
  created(){
    this.getdata()
  },
  methods:{
    reset(){
      this.pagination.current = 1;
      this.searchTerm = {};
      this.getdata();
    },
    search(){
      this.pagination.current = 1;
      this.getdata();
    },
    getdata(){
      let params = {...this.searchTerm};
      params.nature = 2;
      params.pageNum = this.pagination.current
      this.$http.post('supplyCost/queryRecordList',params).then(res=>{
        this.data = res.rows
        this.pagination.total = res.count;
      })
    },
    openModal(account){
      this.$router.push({name:'order-settlement',query:{id:account,title:"订单结算"}})
    },
  }
};
</script>
